<div
  class="cp al-glass al-glass--popover"
  role="dialog"
  [attr.aria-label]="'components.colorPicker.dialogLabel' | translate"
>
  <div class="al-glass__body cp__body">
    <!-- Reiter — nur, wenn das Feld Verläufe erlaubt ([allowGradient]). -->
    @if (allowGradient) {
    <div class="cp-segment cp-segment--tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="cp-segment__item"
        data-mode="solid"
        [class.al-pressed]="mode === 'solid'"
        [attr.aria-selected]="mode === 'solid'"
        [attr.tabindex]="mode === 'solid' ? 0 : -1"
        (click)="setMode('solid')"
        (keydown)="onTabKeydown($event)"
      >
        {{ 'components.colorPicker.tabSolid' | translate }}
      </button>
      <button
        type="button"
        role="tab"
        class="cp-segment__item"
        data-mode="gradient"
        [class.al-pressed]="mode === 'gradient'"
        [attr.aria-selected]="mode === 'gradient'"
        [attr.tabindex]="mode === 'gradient' ? 0 : -1"
        (click)="setMode('gradient')"
        (keydown)="onTabKeydown($event)"
      >
        {{ 'components.colorPicker.tabGradient' | translate }}
      </button>
    </div>
    }

    @if (mode === 'gradient') {
    <!-- Verlauf: Art, Winkel, Umkehren -->
    <div class="cp-row cp-row--gradient-head">
      <div
        class="cp-segment cp-segment--types"
        role="radiogroup"
        [attr.aria-label]="'components.colorPicker.typeLabel' | translate"
      >
        @for (type of gradientTypes; track type) {
        <button
          type="button"
          role="radio"
          class="cp-segment__item"
          [attr.data-type]="type"
          [class.al-pressed]="gradientType === type"
          [attr.aria-checked]="gradientType === type"
          (click)="setType(type)"
        >
          {{ 'components.colorPicker.types.' + type | translate }}
        </button>
        }
      </div>
      <button
        type="button"
        class="cp-icon-button"
        data-action="reverse"
        [attr.aria-label]="'components.colorPicker.reverse' | translate"
        [nbTooltip]="'components.colorPicker.reverse' | translate"
        (click)="reverse()"
      >
        <nb-icon icon="swap-outline"></nb-icon>
      </button>
    </div>

    <div class="cp-gradient-preview cp-checker">
      <span [style.background]="view.gradientCss"></span>
    </div>

    <!-- Leiste mit Stopps: Klick fügt hinzu, Griffe ziehen, Pfeiltasten
         verschieben, Entf entfernt. -->
    <div
      class="cp-bar cp-checker"
      [attr.aria-label]="'components.colorPicker.gradientBar' | translate"
      (click)="onBarClick($event)"
    >
      <span class="cp-bar__fill" [style.background]="view.barCss"></span>
      @for (stop of stops; track stop.id) {
      <button
        type="button"
        class="cp-stop-handle"
        role="slider"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="stop.position"
        [attr.aria-valuetext]="stop.position + '%'"
        [attr.aria-label]="'components.colorPicker.stop' | translate: { n: stopLabelIndex(stop) }"
        [class.is-selected]="stop.id === selectedStopId"
        [style.left.%]="stop.position"
        (pointerdown)="onStopPointerDown(stop, $event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp()"
        (pointercancel)="onPointerUp()"
        (keydown)="onStopKeydown(stop, $event)"
        (focus)="selectStop(stop.id)"
      >
        <span class="cp-checker"><span [style.background]="stop.hex" [style.opacity]="stop.alpha"></span></span>
      </button>
      }
    </div>

    @if (gradientType !== 'radial') {
    <label class="cp-inline-field">
      <span class="cp-label">{{ 'components.colorPicker.angle' | translate }}</span>
      <input
        class="cp-input cp-input--num"
        type="number"
        min="0"
        max="359"
        step="1"
        data-field="angle"
        [value]="angle"
        (change)="onAngleInput($event)"
      />
      <span class="cp-unit">°</span>
    </label>
    }
    }

    <!-- Farb-Editor: Einfarbig, bzw. der gewählte Stopp im Verlauf. -->
    <div
      class="cp-sv"
      tabindex="0"
      role="slider"
      [attr.aria-label]="'components.colorPicker.saturation' | translate"
      [attr.aria-valuetext]="view.editHex"
      [style.background-color]="view.hueColor"
      (pointerdown)="onPointerDown('sv', $event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp()"
      (pointercancel)="onPointerUp()"
      (keydown)="onSvKeydown($event)"
    >
      <span
        class="cp-thumb"
        [style.left.%]="hsv.s * 100"
        [style.top.%]="(1 - hsv.v) * 100"
        [style.background-color]="view.editHex"
      ></span>
    </div>

    <div class="cp-row cp-row--sliders">
      @if (eyeDropperSupported) {
      <button
        type="button"
        class="cp-icon-button"
        data-action="eyedropper"
        [attr.aria-label]="'components.colorPicker.eyedropper' | translate"
        [nbTooltip]="'components.colorPicker.eyedropper' | translate"
        (click)="pickFromScreen()"
      >
        <nb-icon icon="droplet-outline"></nb-icon>
      </button>
      }
      <div class="cp-sliders">
        <div
          class="cp-slider cp-slider--hue"
          tabindex="0"
          role="slider"
          aria-valuemin="0"
          aria-valuemax="360"
          [attr.aria-valuenow]="hsv.h | number: '1.0-0'"
          [attr.aria-label]="'components.colorPicker.hue' | translate"
          (pointerdown)="onPointerDown('hue', $event)"
          (pointermove)="onPointerMove($event)"
          (pointerup)="onPointerUp()"
          (pointercancel)="onPointerUp()"
          (keydown)="onHueKeydown($event)"
        >
          <span class="cp-slider__thumb" [style.left.%]="hsv.h / 3.6" [style.background-color]="view.hueColor"></span>
        </div>
        <div
          class="cp-slider cp-slider--alpha cp-checker"
          tabindex="0"
          role="slider"
          aria-valuemin="0"
          aria-valuemax="100"
          [attr.aria-valuenow]="view.editAlphaPct"
          [attr.aria-valuetext]="view.editAlphaPct + '%'"
          [attr.aria-label]="'components.colorPicker.opacity' | translate"
          (pointerdown)="onPointerDown('alpha', $event)"
          (pointermove)="onPointerMove($event)"
          (pointerup)="onPointerUp()"
          (pointercancel)="onPointerUp()"
          (keydown)="onAlphaKeydown($event)"
        >
          <span class="cp-slider__fill" [style.background]="view.alphaTrack"></span>
          <span class="cp-slider__thumb" [style.left.%]="view.editAlphaPct">
            <span [style.background-color]="view.editHex" [style.opacity]="view.editAlphaPct / 100"></span>
          </span>
        </div>
      </div>
      <span class="cp-current cp-checker" aria-hidden="true">
        <span [style.background]="view.editCss"></span>
      </span>
    </div>

    <div class="cp-row cp-row--values">
      <label class="cp-field cp-field--hex">
        <span class="cp-label">{{ 'components.colorPicker.hex' | translate }}</span>
        <input
          class="cp-input"
          type="text"
          spellcheck="false"
          maxlength="9"
          data-field="hex"
          [value]="view.editHex"
          (change)="onHexInput($event)"
        />
      </label>
      <label class="cp-field">
        <span class="cp-label">{{ 'components.colorPicker.red' | translate }}</span>
        <input class="cp-input cp-input--num" type="number" min="0" max="255" data-field="r"
          [value]="view.editRgb.r" (change)="onRgbInput('r', $event)" />
      </label>
      <label class="cp-field">
        <span class="cp-label">{{ 'components.colorPicker.green' | translate }}</span>
        <input class="cp-input cp-input--num" type="number" min="0" max="255" data-field="g"
          [value]="view.editRgb.g" (change)="onRgbInput('g', $event)" />
      </label>
      <label class="cp-field">
        <span class="cp-label">{{ 'components.colorPicker.blue' | translate }}</span>
        <input class="cp-input cp-input--num" type="number" min="0" max="255" data-field="b"
          [value]="view.editRgb.b" (change)="onRgbInput('b', $event)" />
      </label>
      <label class="cp-field">
        <span class="cp-label">%</span>
        <input class="cp-input cp-input--num" type="number" min="0" max="100" data-field="alpha"
          [attr.aria-label]="'components.colorPicker.opacity' | translate"
          [value]="view.editAlphaPct" (change)="onAlphaInput($event)" />
      </label>
    </div>

    @if (mode === 'gradient') {
    <!-- Stoppliste wie in Figma: Position, Farbe, Deckkraft, entfernen. -->
    <div class="cp-stops">
      <div class="cp-stops__head">
        <span class="cp-label">{{ 'components.colorPicker.stops' | translate }}</span>
        <button
          type="button"
          class="cp-icon-button cp-icon-button--small"
          data-action="add-stop"
          [attr.aria-label]="'components.colorPicker.addStop' | translate"
          [nbTooltip]="'components.colorPicker.addStop' | translate"
          (click)="addStop()"
        >
          <nb-icon icon="plus-outline"></nb-icon>
        </button>
      </div>
      @for (stop of stops; track stop.id) {
      <div class="cp-stop-row" [class.is-selected]="stop.id === selectedStopId">
        <input
          class="cp-input cp-input--num cp-input--pos"
          type="number"
          min="0"
          max="100"
          data-field="stop-position"
          [attr.aria-label]="('components.colorPicker.stop' | translate: { n: $index + 1 }) + ' · ' + ('components.colorPicker.stopPosition' | translate)"
          [value]="stop.position"
          (focus)="selectStop(stop.id)"
          (change)="onStopPositionInput(stop, $event)"
        />
        <button
          type="button"
          class="cp-stop-swatch cp-checker"
          [attr.aria-label]="'components.colorPicker.stop' | translate: { n: $index + 1 }"
          [attr.aria-pressed]="stop.id === selectedStopId"
          (click)="selectStop(stop.id)"
        >
          <span [style.background]="stop.hex" [style.opacity]="stop.alpha"></span>
        </button>
        <input
          class="cp-input cp-input--stop-hex"
          type="text"
          spellcheck="false"
          maxlength="7"
          data-field="stop-hex"
          [attr.aria-label]="('components.colorPicker.stop' | translate: { n: $index + 1 }) + ' · ' + ('components.colorPicker.hex' | translate)"
          [value]="stop.hex"
          (focus)="selectStop(stop.id)"
          (change)="onStopHexInput(stop, $event)"
        />
        <input
          class="cp-input cp-input--num cp-input--opacity"
          type="number"
          min="0"
          max="100"
          data-field="stop-opacity"
          [attr.aria-label]="('components.colorPicker.stop' | translate: { n: $index + 1 }) + ' · ' + ('components.colorPicker.opacity' | translate)"
          [value]="stop.alpha * 100 | number: '1.0-0'"
          (focus)="selectStop(stop.id)"
          (change)="onStopOpacityInput(stop, $event)"
        />
        <button
          type="button"
          class="cp-icon-button cp-icon-button--small"
          data-action="remove-stop"
          [disabled]="stops.length <= 2"
          [attr.aria-label]="'components.colorPicker.removeStop' | translate"
          [nbTooltip]="'components.colorPicker.removeStop' | translate"
          [nbTooltipDisabled]="stops.length <= 2"
          (click)="removeStop(stop.id)"
        >
          <nb-icon icon="minus-outline"></nb-icon>
        </button>
      </div>
      }
    </div>
    }
  </div>
</div>
